export default __webpack_public_path__ + "static/media/aa-master-active.3ba28469.svg";